import Branding from "../../components/header/branding"

export default Branding
